<template>
  <ui-component-modal
    modalTitle="Change activation status"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :onClickCancel="onClickCancel"
    :onClickSave="updateActivationStatus"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template v-slot:content>
      <div class="select">
        <select v-model="selectedStatus">
          <option
            v-for="statusType in statusTypes"
            :key="statusType.Id"
            :value="statusType.Status"
            :selected="statusType.Status === selectedStatus"
          >
            {{ statusType.Name }}
          </option>
        </select>
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import locationProvider from '@/providers/location'

export default {
  components: {},

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      statusTypes: [],
      selectedStatus: '',
    }
  },

  computed: {
    ...mapState('locationStore', ['location', 'locationState']),
  },

  created() {
    this.selectedStatus = this.locationState.ActivationStatus

    this.statusTypes.push({ Id: -1, Name: 'Denied', Status: 'Denied' })
    this.statusTypes.push({ Id: 0, Name: 'Setup location', Status: 'Neutral' })
    this.statusTypes.push({
      Id: 1,
      Name: 'Activation request',
      Status: 'Requested',
    })
    this.statusTypes.push({ Id: 2, Name: 'Activated', Status: 'Activated' })
    this.statusTypes.push({ Id: 3, Name: 'Stopped', Status: 'Stopped' })
  },

  methods: {
    ...mapMutations('locationStore', ['setLocation', 'setLocationState']),

    updateActivationStatus() {
      let self = this

      if (!self.isSaving) {
        self.isSaving = true

        locationProvider.methods
          .updateActivationStatus(self.location.Id, self.selectedStatus)
          .then((response) => {
            if (response.status === 200) {
              self.setLocationState(response.data)
              self.onClickCancel()
            }
          })
          .catch((e) => {
            self.isSavingError = true
          })
          .finally(() => {
            self.isSaving = false
          })
      }
    },
  },
}
</script>
